import { GridColDef } from "@mui/x-data-grid";
import Table from "../custom/Table";
import { TColumn } from "../../Models/common";
import { TCharge } from "../../Models/Inbound";
import { useContext, useEffect } from "react";
import { TransactionContext } from "../../contexts/TransactionContext";
import { TOrderCharges } from "../../Models/Transactions";
import { CHARGE_TYPES, IMPURE_METALS, TAX_PERCENTAGE, TRANSACTION_STATUS, TRANSACTION_TYPES } from "../../utils/constant";
import useService from "../../hooks/useService";
import { fetchCharges } from "../../services/Transactions";

const CHARGES_COLUMN: TColumn<TOrderCharges>[] = [
    {
        field: "name",
        headerName: 'Charge Name',
        minWidth: 200
    },
    {
        field: "basis",
        headerName: 'Basis',
    },
    {
        field: "additionalInformation",
        headerName: 'Product',
    },
    {
        field: "unitPrice",
        headerName: 'Unit Price',
    },
    {
        field: "quantity",
        headerName: 'Quantity',
    },
    {
        field: "preTaxAmount",
        headerName: 'Pre Tax Amount',
        minWidth: 150
    },
    {
        field: "taxPercentage",
        headerName: 'Tax Percentage',
        minWidth: 150
    },
    {
        field: "postTaxAmount",
        headerName: 'Post Tax Amount',
        minWidth: 150
    },
]

function Charges(props: any) {
    const { store, execute } = useService()
    const { transactionsStore, customerStore } = store
    const { charges, setCharges, physicalOrder, inboundOrder, meltingLot, transactionInfo, inboundDetails } = transactionsStore
    const { customerConfig } = customerStore

    const getCharges = () => {
        const chargesRow: TOrderCharges[] = [];
        if (transactionInfo.status === TRANSACTION_STATUS.INBOUND_INITIATED) {
            charges.forEach(charge => {
                const calculatedCharge = calculateCharges(charge)
                if (calculatedCharge != null) chargesRow.push(calculatedCharge)
            })
        } else {
            (physicalOrder.charges?.length ? physicalOrder.charges! : inboundOrder.charges!)?.forEach(charge => {
                charge = {
                    ...charge,
                    basis: charge.basis || 'N/A',
                    additionalInformation: charge.additionalInformation?.product?.name || 'N/A' as any
                }
                chargesRow.push(charge)
            })
        }
        console.log('calculated charges...', chargesRow)
        return chargesRow
    }

    const calculateCharges = (charge: TCharge) => {

        let quantity = 0
        let unitPrice = 0
        console.log(charge.id,transactionInfo.transactionType,'charge_id')

        switch (transactionInfo.transactionType) {
            case TRANSACTION_TYPES.BUY_SELL:
                if (customerConfig.saperateCharges) {
                    if (charge.id === CHARGE_TYPES.REFINING_CHARGE) {
                        quantity = inboundDetails.shipmentWeight || 0
                        unitPrice = customerConfig.refiningCharges || 0
                    }
                    else if (charge.id === CHARGE_TYPES.MELTING_CHARGE) {
                        quantity = meltingLot.length || 0
                        unitPrice = charge.unitValue || 0
                    }
                    console.log('quantity', quantity)
                    console.log('unitPrice', unitPrice)
                }
                break;

            case TRANSACTION_TYPES.JOB_WORK:
                if (charge.id === CHARGE_TYPES.REFINING_CHARGE) {
                    quantity = inboundDetails.shipmentWeight || 0
                    unitPrice = customerConfig.refiningCharges || 0
                }
                else if (charge.id === CHARGE_TYPES.MELTING_CHARGE) {
                    quantity = meltingLot.length || 0
                    unitPrice = charge.unitValue || 0
                }
                break;

            case TRANSACTION_TYPES.PURITY_TESTING:
                if (charge.id === CHARGE_TYPES.PURITY_TESTING_CHARGE) {
                    quantity = meltingLot.length || 0
                    unitPrice = customerConfig.purityVerificationCharges || 0
                }
                break;

            default:
                break;
        }

        if (charge.id === CHARGE_TYPES.PGM_CHARGE) {
            unitPrice = charge.unitValue || 0
             meltingLot.forEach(lot => {
                const xrfReport = lot.xrfReport
                let totalImpurity = 0
                for (let element in xrfReport) {
                    if (IMPURE_METALS.includes(element)) totalImpurity += xrfReport[element]
                }
                const averageImpurity = totalImpurity / IMPURE_METALS.length
                 if(averageImpurity > 0.2){
                    quantity += lot.netWeight 
                 }
            })
            
        }

        if (quantity) {
            const preTaxAmount = unitPrice * quantity
            const taxPercentage = TAX_PERCENTAGE.SERVICE
            const postTaxAmount = preTaxAmount + (preTaxAmount * taxPercentage / 100)

            const orderCharge: TOrderCharges = {
                name: charge.name,
                basis: charge.basis,
                preTaxAmount,
                quantity,
                taxPercentage: TAX_PERCENTAGE.SERVICE,
                unitPrice: unitPrice,
                postTaxAmount: Number(postTaxAmount.toFixed(2)),
                id: charge.id
            } as TOrderCharges

            return orderCharge
        }
        else return null
    }

    useEffect(() => {
        execute(() => fetchCharges({
            globalTransactionNumber: transactionInfo.globalTransactionNumber!,
            transactionType: transactionInfo.transactionType
        }))
    }, [])

    return <div style={{ padding: '20px 10px' }}>
        <div >
            <Table columns={CHARGES_COLUMN} rows={getCharges()} />
        </div>
    </div>
}

export default Charges